export default `uniform sampler2D uGlyphAtlas;
uniform float uGlyphCount;
uniform vec3 uColorCore; 
uniform vec3 uColorWarm; 
uniform float uAlphaCut; 

varying float vGlyph;
varying float vBright;
varying float vAlpha;

void main() {
  vec2 uv = gl_PointCoord;
  float cw = 1.0 / uGlyphCount;
  vec2 atlasUv = vec2((vGlyph + uv.x) * cw, uv.y);
  float mask = texture2D(uGlyphAtlas, atlasUv).a;
  if (mask < 0.06) discard;

  float a = mask * vAlpha;
  
  
  
  if (a < uAlphaCut) discard;

  vec3 col = mix(uColorWarm, uColorCore, clamp(vBright, 0.0, 1.0));
  gl_FragColor = vec4(col, a);
}`